export default "__VITE_ASSET__CeFIccKr__"